module.exports = __webpack_public_path__ + "static/media/6.cfe9d0c2.mp4";